<template>
  <div class="t-spinner" role="progressbar" :style="{color: color, fontSize: fontSize}">
    <div v-for="line in lines" :key="line"></div>
  </div>
</template>

<script>
export default {
  name: 't-spinner',
  props: {
    color: {
      type: String,
      required: false,
      default: '#ffffff',
    },
    fontSize: {
      type: String,
      required: false,
      default: '2rem',
    },
  },

  data: () => ({
    lines: Array.from({ length: 12 }, (x, i) => i),
  }),
};
</script>
